import React from 'react';
import { NavLink } from 'react-router-dom';

const PatientHeader = ({title}) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-5 about_section">
          <h2 className="font-weight-bold py-4" style={{letterSpacing: "1px"}}>{title}</h2>
        </div>
        <div className="col-lg-7 text-right about_section">
          <div className="d-inline-flex h-100 align-items-center">
          <NavLink exact to="/patient/dashboard" activeClassName="pageactive" className="text-uppercase text-dark mx-4 footer_link font-weight-bold" >Dashboard</NavLink>
          <NavLink exact to="/patient/profile" activeClassName="pageactive" className="text-uppercase text-dark mx-4 footer_link font-weight-bold" >Profile</NavLink>
          <button className="text-uppercase bg-none text-dark mx-4 footer_link font-weight-bold" >Signout</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientHeader;